/**
 * Returns an `origin` value from an href attribute
 *
 * @param  {string} href
 * @returns {string}
 */
export default function getOrigin(href) {
  const url = new URL(href);
  return url.origin;
}
